import { useState, useRef, useEffect } from "react";
import "./dashboard-navbar.scss";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { Constants } from "../../../constants/Contants";
import { toast } from "react-toastify";
import { getAllUnreadNotifications, updateNotification } from "../../../requests/notificationApi";

// const socket = io(Constants.baseURL);

const DashboardNav = ({ toggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([])
  const handleLogout = () => {
    localStorage.removeItem("teleport_admin_data");
    localStorage.removeItem("teleport_admin_token");
    navigate("/admin-login");
  };

  useEffect(() => {
  getNotification();

  const handleNotification = (data) => {
    getNotification();
    toast.info(data.message);
  };

  // socket.on("getNotification", handleNotification);

  // return () => {
  //   socket.off("getNotification", handleNotification);
  // };
}, []);

  const getNotification = async() => {
    const notifs = await getAllUnreadNotifications();
    if(notifs?.status) {
      setNotifications(notifs.data)
    } else {
      toast.error(notifs?.message)
    }
  }

  const [openDropdown, setOpenDropdown] = useState(null); // 'notifications', 'profile', or null
  const wrapperRef = useRef();

  const handleNotClick = (note) => {
    updateNotification(note._id, { isRead: true})
    getNotification()
    navigate("/merchant-details", { state: { data: note.merchantId } });
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    // document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div className="dashboard-navbar">
      <div className="navbar-left">
        <button
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          ☰
        </button>
        <Link to="/">
          <img src="/images/navbar-logo.svg" alt="logo" />
        </Link>
      </div>
      <div className="navbar-right">
        {/* Notifications Dropdown */}
        <div className="dropdown notifications-dropdown" ref={wrapperRef}>
          <button
            type="button"
            onClick={() =>
              setOpenDropdown(
                openDropdown === "notifications" ? null : "notifications"
              )
            }
            className="notification-button"
          >
            <img
              src="/images/icons/notification-bell.svg"
              alt="Notifications"
              className="notification-icon"
            />
            <span className="notification-count">{notifications.length}</span>
          </button>

          <ul
            className={`dropdown-menu dropdown-menu-end ${
              openDropdown === "notifications" ? "show" : ""
            }`}
          >
            <li className="dropdown-header">Notifications</li>
            {notifications.map((note) => (
              <li
                key={note._id}
                className="dropdown-item notification-item"
                onClick={(e) => {
                  e.stopPropagation();
                  handleNotClick(note);
                }}
              >
                <div>
                  <p className="notification-title">{note.message}</p>
                  <span className="notification-time">{note.creates_at}</span>
                </div>
              </li>
            ))}
            {/* <li className="view-all">
              <a href="/notifications">View All</a>
            </li> */}
          </ul>
        </div>
        {/* Profile Dropdown */}
        <div className="dropdown profile-dropdown" ref={wrapperRef}>
          <button
            type="button"
            onClick={() =>
              setOpenDropdown(openDropdown === "profile" ? null : "profile")
            }
            className="profile-button"
          >
            <img
              src="/images/collaborations/team.svg"
              alt="User Avatar"
              className="user-avatar"
            />
          </button>

          <ul
            className={`dropdown-menu dropdown-menu-end ${
              openDropdown === "profile" ? "show" : ""
            }`}
          >
            <li>
              <span
                className="dropdown-item"
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                Logout
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashboardNav;
